<section class="video-board row justify-content-center gx-0" [ngClass]="{ hide: visible }">
  <!-- Sidebar -->
  <div class="col-md-3 sidebar">
    <h1 class="genre-title">{{ genre }}</h1>

    <ng-container *ngFor="let levelKey of categorizedLevels | keyvalue">
      <div class="level-block">
        <div class="level-title">{{ levelKey.key }}</div>
        <div class="lesson-link" *ngFor="let item of levelKey.value; let i = index"
          [class.active]="i === active && flag === levelKey.key" (click)="setVideo(i, levelKey.key)">
          {{ i + 1 }}. {{ item.title }}
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Content Area -->
  <div class="col-md-9 video-content px-3 px-md-4">
    <div class="toggle-sidebar mb-3" (click)="setVisibility()">
      <img src="assets/images/icons/ic_playlist.png" alt="Toggle Playlist" loading="lazy" />
    </div>

    <div class="video-section">
      <h2 class="video-title">
        {{ data?.title }}
      </h2>

      <div class="video-player-container">
        <video
          #videoPlayer
          class="video-player w-100"
          [ngClass]="getQualityClass()"
          controls
          controlsList="nodownload"
          [src]="getVideoSource()"
          autoplay
          playsinline
          webkit-playsinline
          preload="auto"
          (ended)="playNextVideo()"
        >
          Your browser doesn't support video playback.
        </video>

        <!-- Video Quality Overlay Menu -->
        <div class="video-quality-overlay">
          <button
            type="button"
            class="quality-toggle-btn d-flex align-items-center gap-1"
            (click)="toggleQualityMenu($event)"
            title="Select Video Quality"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
              <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872zM8 10.93a2.93 2.93 0 1 1 0-5.86 2.93 2.93 0 0 1 0 5.86"/>
            </svg>
            <span class="quality-label">{{ selectedQuality }}</span>
          </button>

          <div *ngIf="showQualityMenu" class="quality-dropdown-menu">
            <div class="quality-header">Quality</div>
            <button
              *ngFor="let q of availableQualities"
              type="button"
              class="quality-option-btn d-flex align-items-center justify-content-between"
              [class.active]="selectedQuality === q"
              (click)="changeQuality(q)"
            >
              <span>{{ q }}</span>
              <svg *ngIf="selectedQuality === q" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Media Controls (Backward, Forward, Next) -->
      <div class="media-controls-bar d-flex flex-wrap align-items-center justify-content-between my-3 p-3 rounded">
        <div class="d-flex align-items-center gap-2">
          <button type="button" class="control-btn seek-btn" (click)="skipBackward(10)" title="Rewind 10 seconds">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-arrow-counterclockwise me-1" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z" />
              <path
                d="M8 1.05a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .854.354l1.5-1.5a.5.5 0 0 0 0-.708l-1.5-1.5A.5.5 0 0 0 8 1.05" />
            </svg>
            Backward 10s
          </button>

          <button type="button" class="control-btn seek-btn" (click)="skipForward(10)" title="Forward 10 seconds">
            Forward 10s
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-arrow-clockwise ms-1" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
              <path
                d="M8 1.05a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.854.354l-1.5-1.5a.5.5 0 0 1 0-.708l1.5-1.5A.5.5 0 0 1 8 1.05" />
            </svg>
          </button>
        </div>

        <div>
          <button type="button" class="control-btn next-btn" [disabled]="!hasNextVideo()" (click)="playNextVideo()"
            title="Play next video in course">
            Next Video
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-skip-end-fill ms-1" viewBox="0 0 16 16">
              <path
                d="M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.008 1.233.697L11.5 8.752V12a.5.5 0 0 0 1 0z" />
            </svg>
          </button>
        </div>
      </div>

      <div class="video-description">
        <h4>Short Description</h4>
        <p>{{ data?.short_description }}</p>

        <h4>Description</h4>
        <p>{{ data?.description }}</p>
      </div>
    </div>
  </div>
</section>